import axios from '@/api/axios'

const createUser = (userInput) => {
  return axios.post('/users', userInput)
}

const getUsers = (params) => {
  return axios.get('/usersListForAdmin', {params})
}

const getUser = (id) => {
  return axios.get(`/users/${id}`)
}

const updateUser = (id, userInput) => {
  return axios.put(`/users/${id}`, userInput)
}

const resetPasswordUser = (passwords) => {
  return axios.post(`/users/${passwords.userId}/reset/password`, passwords)
}

const deleteUser = (userId) => {
  return axios.delete(`/users/${userId}`)
}

export default {
  createUser,
  getUsers,
  getUser,
  updateUser,
  resetPasswordUser,
  deleteUser,
}
